import { request } from '../../common/CustomSuperagent';
import { serverURLs } from '../../common/config'

export const fetchRecipeList = (searchTerm) => {
  return request()
    .get(serverURLs.recipe + '?fields=id,title&limit=5&search=' + searchTerm)
    .then(res => {
      return res.body.results.map(recipe => {
        return { name: recipe.title, char: recipe.title };
      });
    })
    .catch(err => [])
};



// WEBPACK FOOTER //
// ./modules/recipe_form/actions/RecipeListActions.js